<div class="calculation-results" [ngClass]="[this.menuService.menuOptions['calculation-results'] ? 'active' : '' , toolService.navigationOnTop ? 'footer-active' : '']" style="width: 350px;">
  <div class="calculation-results__container">
    <div class="calculation-results__container__title">
      <h1>
        <input type="checkbox" (click)="selectAllCalculations($event)" [checked]="true">
        Calculation Results
      </h1>

      <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
      <div class="hiddenMenu down" (mouseleave)="utilsService.closeHiddenMenu($event)">
        <ul>
          <li (click)="mapService.moveLayersToFront(this.globalSelectionService.calculationLayers.childLayers)">Move To Front</li>
          <li  (click)="mapService.moveLayersToBack(this.globalSelectionService.calculationLayers.childLayers)">Move To Back</li>
          <li (click)="exportDataService.exportDataToShapeFile(getCalculationLayers())">Export Data</li>
        </ul>
      </div>

      <div class="remove" (click)="deleteSelectedCalculationsClickEvent()"></div>

      <div class="minimize" (click)="this.menuService.menuOptions['calculation-results'] = false">
        <img src="/assets/img/close.svg" alt="">
      </div>
    </div>

    <div class="calculation-results__tab" [ngClass]="[(this.globalSelectionService.calculationLayers.active || this.globalSelectionService.horizonToolLayers.active) ? 'active' : '', this.globalSelectionService.calculationLayers.childLayers.length > 0? 'somePerformances' : '']">
      <ng-container *ngIf="this.pointsService.horizonToolLayer.childLayers[0].layers[0].olLayer.getSource().getFeatures().length > 0">
        <div class="field"  *ngFor="let child of this.globalSelectionService.horizonToolLayers.childLayers">
          <div>
            <div>
              <div (click)="this.globalSelectionService.calculationLayers.clicked(child)" class="calculation-results__tab__sec" [ngClass]="child.status ? 'active' : ''">
                <div class="title">
                  <input type="checkbox" (click)="selectCalculation(child,false)" [checked]="child.allVisible()"/>
                  <span (click)="this.globalSelectionService.horizonToolLayers.clickEvent(child)" style="padding-left: 10px;" class="trigger" title="{{child.name}}">{{child.name}}</span>
                  <span (click)="deleteHorizonToolResultAndCloseTab()" class="remove" style="width: 13px;height: 13px; margin-left: 0;"></span>
                  <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                  <div class="hiddenMenu down hiddenMenu__mr--33" (mouseleave)="utilsService.closeHiddenMenu($event)">
                    <ul>
                      <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                      <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                      <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                      <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data To KML</li>
                      <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To Shape File</li>
                    </ul>
                  </div>
                </div>
                <div class="calculation-results__tab__third" [ngClass]="child.layers[0].expanded ? 'active' : ''">
                  <div class="calculation-results__tab__third" *ngFor="let horizon_color of child.horizon_tool_info | keyvalue; let j = index" [attr.data-index]="j">
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : horizon_color.value}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                        <span>{{horizon_color.key}}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="field" *ngFor="let child of getCalculations()">
          <div *ngIf="child.type == 'DocAndSectorizationDisplay'; else coverage" (click)="this.globalSelectionService.calculationLayers.clicked(child)" class="calculation-results__tab__sec" [ngClass]="child.status ? 'active' : ''">
            <div class="title">
              <input type="checkbox" name="a_calculation_checkbox" data-id="{{child.calcID}}" (click)="selectCalculation(child,true,true)" [checked]="child.allVisible()" />
              <span (click)="this.globalSelectionService.calculationLayers.clickEvent(child)" style="padding-left: 5px;" class="trigger" title="{{child.name}}">{{child.name}}</span>
              <span (click)="deleteCalculation(child, isDeleteAll)" name="a_calculation_delete_icon" class="remove" style="width: 15px;height: 15px; margin-left: 0;"></span>
              <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
              <div class="hiddenMenu down hiddenMenu__mr--40" (mouseleave)="utilsService.closeHiddenMenu($event)">
                <ul>
                  <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                  <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                  <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                  <li (click)="renameCalculation(child)">Rename Calculation</li>
                  <li (click)="openAnalysisTool(child)">Analysis Tool</li>
                  <li (click)="openCalculationConfiguration(child.calcID, child.type)">Calculation Configuration</li>
                  <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data To KML</li>
                  <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To Shape File</li>
                </ul>
              </div>
            </div>
            <div *ngFor="let navaid of child.navaids_info | keyvalue; let j = index" [attr.data-index]="j" class="calculation-results__tab__third" [ngClass]="child.layers[j].expanded ? 'active' : ''">
              <div class="field">
                <input type="checkbox" (click)="this.selectSubLayerDocSectorization(child, navaid.key)" [checked]="getDocAndSectorizationVisibility(child,navaid.key)" />
                <span> <img src="" alt=""/></span>
                <span class="trigger" title="Doc and Sectorization: {{navaid.key}}" (click)="this.globalSelectionService.calculationLayers.displayLegend(navaid.key, child)">Doc and Sectorization: {{navaid.key}}</span>
              </div>
              <div  [attr.data-index]="i" *ngFor="let item of navaid.value; let i = index">
                <div class="third__container" [ngClass]="child.navaids_expanded_info.get(navaid.key) ? 'active' : ''">
                  <ng-container>
                    <div class="field"  style="padding-left: 20px;">
                      <span *ngIf="i < navaid.value.length - 1; else last" >
                        <img src="/assets/img/cal-blue.svg" alt=""/>
                        <span> {{item}}</span>
                      </span>
                      <ng-template #last>
                          <span >
                            <!-- <img src="/assets/img/cal-blue-3.svg" alt=""/> -->
                            <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : color}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                            <span> {{item}}</span>
                          </span>
                      </ng-template>
                    </div>
                  </ng-container>
                </div>
              </div>

            </div>
          </div>

      <ng-template #coverage>
        <div *ngIf="child.type == 'Coverage' || child.type == 'Impact Assessment' ; else performance">
          <div>
              <div [ngClass]="child.status ? 'active' : ''" class="calculation-results__tab__sec" style="align-items: center; ">
                <div class="title">
                  <input type="checkbox" name="a_calculation_checkbox" data-id="{{child.calcID}}" (click)="selectCalculation(child,false)" [checked]="child.allVisible()" />
                  <span style="padding-left: 5px;" class="trigger" (click)="this.globalSelectionService.calculationLayers.clickEvent(child)" title="{{child.name}}">{{child.name}}</span>
                  <ng-container *ngIf="interferenceTestService.projectInterferenceTest?.calculationId != child.calcID">
                    <span (click)="deleteCalculation(child, isDeleteAll)" name="a_calculation_delete_icon" class="remove" style="width: 13px;height: 13px; margin-left: 0;"></span>
                  </ng-container>
                  <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                  <div class="hiddenMenu down hiddenMenu__mr--33" (mouseleave)="utilsService.closeHiddenMenu($event)">
                    <ul>
                      <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                      <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                      <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                      <li (click)="renameCalculation(child)">Rename Calculation</li>
                      <li (click)="openAnalysisTool(child)">Analysis Tool</li>
                      <li (click)="openCalculationConfiguration(child.calcID, child.type)">Calculation Configuration</li>
                      <li (click)="exportDataService.exportDataToKML([child.layers[0]])">Export Data To KML</li>
                      <li (click)="exportDataService.exportDataToShapeFile([child.layers[0]])">Export Data To Shape File</li>
                      <li (click)="changeTransparency(child)">Change Transparency</li>
                      <ng-container *ngIf="child.type == 'Coverage'">
                        <li (click)="changeCoverageColor(child)">Change Color</li>
                      </ng-container>
                    </ul>
                  </div>
                </div>
                <div *ngFor="let layer of child.layers" class="calculation-results__tab__third" [ngClass]="layer.expanded ? 'active' : ''">
                  <div *ngFor="let elevation of child.elevation_info | keyvalue; let j = index" [attr.data-index]="j" >
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : elevation.value}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                        <span> {{elevation.key}}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </ng-template>
      <ng-template #performance>
        <div *ngIf="child.type == 'PERFORMANCE' || child.type == 'PROCEDURE_ANALYSIS'; else navaidSitingTool">
          <div>
            <div [ngClass]="child.status ? 'active' : ''"  class="calculation-results__tab__sec">
              <div class="title">
                <input type="checkbox" name="a_calculation_checkbox" data-id="{{child.calcID}}" (click)="selectCalculation(child,true)" [checked]="child.oneVisible()" />
                <span style="padding-left: 5px;" class="trigger" (click)="this.globalSelectionService.calculationLayers.clickEvent(child)" title="{{child.name}}">{{child.name}}</span>
                <button *ngIf="child.type == 'PERFORMANCE'" type="submit" (click)="openCQA(child.calcID)" title="Coverage Quantitative Assessment"></button>
                <span (click)="this.deleteCalculation(child, isDeleteAll)" name="a_calculation_delete_icon" class="remove" style="width: 13px;height: 13px; margin-left: 0;"></span>
                <div  class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                <div class="hiddenMenu down hiddenMenu__mr--40" (mouseleave)="utilsService.closeHiddenMenu($event)">
                  <ul>
                    <li *ngIf="child.type == 'PROCEDURE_ANALYSIS' && isPerformanceAnalysisAvaible(child.calcID)" (click)="this.tabsService.openPerformanceAnalysisCalculation(child.calcID)">Results</li>
                    <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                      <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                    <li (click)="renameCalculation(child)">Rename Calculation</li>
                    <li (click)="openCalculationConfiguration(child.calcID, child.type)">Calculation Configuration</li>
                    <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data To KML</li>
                    <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To Shape File</li>
                  </ul>
                </div>
              </div>
              <div *ngFor="let layer of child.layers;let i = index;" class="calculation-results__tab__third" [ngClass]="layer.expanded ? 'active' : ''">
                  <div  class="dots" style="margin-top: 7px;"(mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                  <div class="hiddenMenu down hiddenMenu__mr--15" (mouseleave)="utilsService.closeHiddenMenu($event)">
                    <ul>
                      <li (click)="mapService.moveLayersToFront([layer])">Move To Front</li>
                      <li (click)="mapService.moveLayersToBack([layer])">Move To Back</li>
                      <li (click)="mapService.zoomToLayers([layer])">Zoom To Layer</li>
                      <li *ngIf="layer.name != 'Available Pairs'" (click)="openAnalysisTool(child, layer.name)">Analysis Tool</li>
                      <li *ngIf="layer.name == 'Available Pairs'" (click)="openAnalysisTool(child, analysisToolService.getPairsAnalysisFlag())">Pairs Analysis Tool</li>
                      <li (click)="exportDataService.exportDataToKML([layer])">Export Data To KML</li>
                      <li (click)="exportDataService.exportDataToShapeFile([layer])">Export Data To Shape File</li>
                      <li (click)="changeTransparencyOfLayers(child.calcID, [layer],child, true)">Change Transparency</li>
                    </ul>
                  </div>
                  <div class="field">
                    <input type="checkbox" (click)="selectSubLayer(child.calcID,layer)" [checked]="layer.visible" />
                    <span> </span>
                    <span class="trigger" style="margin-right: 10px; margin-left: 0;" (click)="this.globalSelectionService.calculationLayers.clickLayerEvent(layer)" title="{{layer.name}}">{{layer.name}}</span>
                  </div>
                  <div *ngIf="layer.name == 'NSE'" class="third__container" [ngClass]="layer.expanded ? 'active' : ''">
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-green-4.svg" alt=""/>
                        <span>0 - 0.2</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-green-3.svg" alt=""/>
                        <span>0.2 - 0.4</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-green-2.svg" alt=""/>
                        <span>0.4 - 0.6</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-green-1.svg" alt=""/>
                        <span>0.6 - 0.866</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-red-1.svg" alt=""/>
                        <span>0.866 - 1</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-red-2.svg" alt=""/>
                        <span>1 - 2</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-red-3.svg" alt=""/>
                        <span>2 - 3</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-red-4.svg" alt=""/>
                        <span>> 3</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-gray.svg" alt=""/>
                        <span>VOID</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="layer.name == 'Redundancy' || layer.name=='Available Pairs' || layer.name=='Signal Delay'" class="third__container" [ngClass]="layer.expanded ? 'active' : ''">
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-gray.svg" alt=""/>
                        <span>No Coverage</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-orange.svg" alt=""/>
                        <span>No Redundancy</span>
                      </span>
                    </div>
                    <div *ngIf="layer.isDMEDME" class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-yellow.svg" alt=""/>
                        <span>Limited Redundancy</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-green.svg" alt=""/>
                        <span>Full Redundancy</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-blue-2.svg" alt=""/>
                        <span>High Redundancy</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="layer.name == 'Subtended Angles'" class="third__container" [ngClass]="layer.expanded ? 'active' : ''">
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-gray.svg" alt=""/>
                        <span>0 - 30</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-red-1.svg" alt=""/>
                        <span>30 - 40</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-red-2.svg" alt=""/>
                        <span>40 - 50</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-yellow.svg" alt=""/>
                        <span>50 - 60</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-blue-2.svg" alt=""/>
                        <span>60 - 70</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-purple.svg" alt=""/>
                        <span>70 - 80</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <img src="/assets/img/cal-green-3.svg" alt=""/>
                        <span>80 - 90</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="layer.name == 'Worst Inertial Drift' || layer.name == 'Center Line Inertial Drift'" class="third__container" [ngClass]="layer.expanded ? 'active' : ''">
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'rgba(255, 0, 0,1)'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                        <span>Max NSE exceeded</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'rgba(0, 0, 255,1)'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                        <span>Max NSE not exceeded</span>
                      </span>
                    </div>
                    <div class="field" style="padding-left: 20px;">
                      <span>
                        <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : 'rgba(0, 255, 0,1)'}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                        <span>Coverage</span>
                      </span>
                    </div>
                  </div>
            </div>
            </div>
          </div>

        </div>
      </ng-template>
      <ng-template #navaidSitingTool>
        <div *ngIf="child.type == 'NavaidSitingTool'; else cumulativeCoverage">
          <div>
            <div [ngClass]="child.status ? 'active' : ''"  class="calculation-results__tab__sec">
              <div class="title">
                <input type="checkbox" name="a_calculation_checkbox" data-id="{{child.calcID}}" (click)="selectCalculation(child,false)" [checked]="child.allVisible()" />
                <span style="padding-left: 10px;" class="trigger" (click)="this.globalSelectionService.calculationLayers.clickEvent(child)" title="{{child.name}}">{{child.name}}</span>
                <span style="color: red;" name="a_calculation_delete_icon" class="remove" style="width: 13px;height: 13px; margin-left: 0;" (click)="deleteCalculation(child, isDeleteAll)" ></span>
                <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                <div class="hiddenMenu down hiddenMenu__mr--40" (mouseleave)="utilsService.closeHiddenMenu($event)">
                  <ul>
                    <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                    <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                    <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                    <li (click)="renameCalculation(child)">Rename Calculation</li>
                    <li (click)="openCalculationConfiguration(child.calcID, child.type)">Calculation Configuration</li>
                    <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data To KML</li>
                    <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To Shape File</li>
                    <li (click)="changeTransparency(child)">Change Transparency</li>
                  </ul>
                </div>
              </div>
              <div *ngFor="let layer of child.layers" class="calculation-results__tab__third" [ngClass]="layer.expanded ? 'active' : ''">
                <div class="field">
                  <input type="checkbox" (click)="selectCalculation(child,false)" [checked]="layer.visible" />
                  <span></span>
                  <span class="trigger" style="margin-right: 10px; margin-left: 0;" (click)="this.globalSelectionService.calculationLayers.clickLayerEvent(layer)" title="{{layer.name}}">{{layer.name}}</span>

                </div>
                <div *ngIf="layer.name == 'Navaid Location Assessment'" class="third__container" [ngClass]="layer.expanded ? 'active' : ''">
                  <div *ngFor="let layer of child.layers" class="calculation-results__tab__third" [ngClass]="layer.expanded ? 'active' : ''">
                    <div class="calculation-results__tab__third">
                      <div *ngFor="let subtitle of layer.subtitles; let j = index" [attr.data-index]="j" class="field" style="padding-left: 20px;">
                        <span >
                          <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : subtitle.color}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                          <span> {{subtitle.label}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </ng-template>
      <ng-template #cumulativeCoverage>
        <div *ngIf="child.type == 'Cumulative Coverage'; else overlap">
          <div>
            <div [ngClass]="child.status ? 'active' : ''" class="calculation-results__tab__sec" style="align-items: center; ">
              <div class="title">
                <input type="checkbox" name="a_calculation_checkbox" data-id="{{child.calcID}}" (click)="selectCalculation(child,false)" [checked]="child.allVisible()" />
                <span style="padding-left: 5px;" class="trigger" (click)="this.globalSelectionService.calculationLayers.clickEvent(child)" title="{{child.name}}">{{child.name}}</span>
                <span (click)="deleteCalculation(child, isDeleteAll)" name="a_calculation_delete_icon" class="remove" style="width: 13px;height: 13px;"></span>
                <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                <div class="hiddenMenu down hiddenMenu__mr--33" (mouseleave)="utilsService.closeHiddenMenu($event)">
                  <ul>
                    <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                    <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                    <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                    <li (click)="renameCalculation(child)">Rename Calculation</li>
                    <li (click)="openAnalysisTool(child)">Analysis Tool</li>
                    <li (click)="openCalculationConfiguration(child.calcID, child.type)">Calculation Configuration</li>
                    <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data To KML</li>
                    <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To Shape File</li>
                    <li (click)="changeTransparency(child)">Change Transparency</li>
                  </ul>
                </div>
              </div>
              <div *ngFor="let layer of child.layers" class="calculation-results__tab__third" [ngClass]="layer.expanded ? 'active' : ''">
                <div class="calculation-results__tab__third">
                  <div *ngFor="let for_color of child.cumulative_coverage_colors; let j = index" [attr.data-index]="j" class="field" style="padding-left: 20px;">
                    <span >
                      <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : for_color}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                      <span> {{j+1}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </ng-template>
      <ng-template #overlap>
        <div *ngIf="child.type == 'Overlap'; else terrainAltitudeCut">
          <div>
            <div [ngClass]="child.status ? 'active' : ''"  class="calculation-results__tab__sec">
              <div class="title">
                <input type="checkbox" name="a_calculation_checkbox" data-id="{{child.calcID}}" (click)="selectCalculation(child,false)" [checked]="child.allVisible()" />
                <span style="padding-left: 10px;" class="trigger" (click)="this.globalSelectionService.calculationLayers.clickEvent(child)" title="{{child.name}}">{{child.name}}</span>
                <span (click)="deleteCalculation(child, isDeleteAll)" name="a_calculation_delete_icon" class="remove" style="width: 13px;height: 13px;"></span>
                <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                <div class="hiddenMenu down hiddenMenu__mr--40" (mouseleave)="utilsService.closeHiddenMenu($event)">
                  <ul>
                    <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                    <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                    <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                    <li (click)="renameCalculation(child)">Rename Calculation</li>
                    <li (click)="openAnalysisTool(child)">Analysis Tool</li>
                    <li (click)="openCalculationConfiguration(child.calcID, child.type)">Calculation Configuration</li>
                    <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data To KML</li>
                    <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To Shape File</li>
                    <li (click)="changeTransparency(child)">Change Transparency</li>
                  </ul>
                </div>
              </div>
              <div *ngFor="let layer of child.layers" class="calculation-results__tab__third" [ngClass]="layer.expanded ? 'active' : ''">
                <div class="field">
                  <input type="checkbox" (click)="selectCalculation(child,false)"[checked]="layer.visible" />
                  <span class="trigger" style="margin-right: 10px; margin-left: 0;" (click)="this.globalSelectionService.calculationLayers.clickLayerEvent(layer)" title="{{layer.layerFreq}}">{{layer.layerFreq}}</span>
                </div>

                <div *ngFor="let for_color of child.overlap_frequency_colors.get(layer.layerFreq); let j = index" [attr.data-index]="j" class="third__container" [ngClass]="layer.expanded ? 'active' : ''">
                  <span >
                    <svg class="test" viewBox="0 0 23.52 21.14"><defs><style>.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14"/><polygon class="cls-2" [ngStyle]="{ fill : for_color}" points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57"/></g></g></svg>
                    <span> {{j+1}}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #terrainAltitudeCut>
        <div *ngIf="child.type == 'TerrainAltitudeCut'">
          <div>
            <div [ngClass]="child.status ? 'active' : ''" class="calculation-results__tab__sec">
              <div class="title">
                <input type="checkbox" name="a_calculation_checkbox" data-id="{{child.calcID}}"
                  (click)="selectCalculation(child,false)" [checked]="child.allVisible()" />
                <span style="padding-left: 10px;" class="trigger"
                  (click)="this.globalSelectionService.calculationLayers.clickEvent(child)"
                  title="{{child.name}}">{{child.name}}</span>
                  <div class="dots" (mouseover)="utilsService.showHiddenMenu($event)" >...</div>
                  <div class="hiddenMenu down hiddenMenu__mr--33" (mouseleave)="utilsService.closeHiddenMenu($event)">
                    <ul>
                      <li (click)="mapService.moveLayersToFront([child])">Move To Front</li>
                      <li (click)="mapService.moveLayersToBack([child])">Move To Back</li>
                      <li (click)="mapService.zoomToLayers([child])">Zoom To Layer</li>
                      <li (click)="renameCalculation(child)">Rename Calculation</li>
                      <li (click)="openCalculationConfiguration(child.calcID, child.type)">Calculation Configuration</li>
                      <li (click)="exportDataService.exportDataToKML(child.layers)">Export Data To KML</li>
                      <li (click)="exportDataService.exportDataToShapeFile(child.layers)">Export Data To Shape File</li>
                      <li (click)="changeTransparency(child)">Change Transparency</li>
                    </ul>
                  </div>
                <span (click)="deleteCalculation(child, isDeleteAll)" name="a_calculation_delete_icon" class="remove"
                  style="width: 13px;height: 13px;"></span>
              </div>
              <div *ngFor="let layer of child.layers" class="calculation-results__tab__third"
                [ngClass]="layer.expanded ? 'active' : ''">
                <div class="field">
                  <input type="checkbox" (click)="selectCalculation(child,false)"
                    [checked]="layer.visible" />
                  <span class="trigger" style="margin-right: 10px; padding-left: 10px;"
                    (click)="this.globalSelectionService.calculationLayers.clickLayerEvent(layer)"
                    title="{{layer.name}}">{{layer.name}}</span>
                </div>

                <div class="third__container"
                  [ngClass]="layer.expanded ? 'active' : ''">
                  <div class="field" style="padding-left: 20px;">
                    <span>
                      <svg class="test" viewBox="0 0 23.52 21.14">
                        <defs>
                          <style>
                            .cls-1,
                            .cls-2 {
                              stroke: #000;
                              stroke-miterlimit: 10;
                            }
                          </style>
                        </defs>
                        <g id="Layer_2" data-name="Layer 2">
                          <g id="Layer_1-2" data-name="Layer 1">
                            <rect class="cls-1" x="0.5" y="0.5" width="1.11" height="20.14" />
                            <polygon class="cls-2" [ngStyle]="{ fill : 'rgba(255, 0, 0, 1)'}"
                              points="11.81 18.57 1.89 18.57 12.38 0.5 22.64 0.5 11.81 18.57" />
                          </g>
                        </g>
                      </svg>
                      <span>Above {{layer.elevation}} feet</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      </div>
    </div>

    <div class="ongoing" [ngClass]="this.globalSelectionService.calculationLayers.childLayers.length > 0? 'somePerformances' : ''">
      <h1>Ongoing Calculations</h1>

      <div class="info-calculation" *ngFor="let onGoingCalc of getSortedProgressMap(progressService.progressMap | keyvalue)">
        <div class="info-container">
          <div class="info-label">Percentage Done:</div>
          <div class="info-value">{{onGoingCalc.value.loadedPercentage}} %</div>
        </div>

        <div class="info-container">
          <div class="info-label">Description:</div>
          <div class="info-value">{{onGoingCalc.value.message}}</div>
        </div>

        <div class="info-container" *ngIf="onGoingCalc.value.calculationName != null && onGoingCalc.value.calculationName != onGoingCalc.value.calculationType">
          <div class="info-label">Calculation Name:</div>
          <div class="info-value">{{onGoingCalc.value.calculationName}}</div>
        </div>

        <div class="info-container">
          <div class="info-label">Calculation Type:</div>
          <div class="info-value"> {{onGoingCalc.value.calculationType}}</div>
        </div>

        <div *ngIf="onGoingCalc.value.projectName" class="info-container">
          <div class="info-label">Project Name:</div>
          <div *ngIf="onGoingCalc.value.projectName != projectService.activeProject.name" class="info-value"> {{onGoingCalc.value.projectName}}</div>
          <div *ngIf="onGoingCalc.value.projectName == projectService.activeProject.name" class="info-value"> Current Project ({{onGoingCalc.value.projectName}})</div>
        </div>
          <div class="info-btn">
            <button type="button" class="gray" *ngIf="showCancel(onGoingCalc)" (click)="cancelCalculation(onGoingCalc.key)">Cancel</button>
          </div>
      </div>

    </div>

  </div>
</div>
